export default [
  { source: 'Oscar Wilde', text: 'Sé tú mismo, los demás puestos ya están ocupados.' },
  { source: 'Oscar Wilde', text: 'Perdona siempre a tus enemigos; nada les molesta más que eso.' },
  {
    source: 'Virginia Satir',
    text: 'No debemos permitir que las percepciones limitadas de otras personas nos definan.'
  },
  { source: 'William Shakespeare', text: 'Esto sobre todo: sé sincero contigo mismo.' },
  {
    source: 'Helen Keller',
    text: 'Caminar con un amigo en la oscuridad es mejor que caminar solo bajo la luz.'
  },
  {
    source: 'Winston Churchill',
    text:
      'Se necesita coraje para ponerse de pie y hablar, pero mucho más para sentarse y escuchar.'
  },
  {
    source: 'Martin Luther King, Jr.',
    text: 'El perdón no es un acto ocasional; es una actitud constante.'
  },
  { source: 'J.R.R. Tolkien', text: 'El coraje se encuentra en sitios insólitos.' },
  { source: 'J.R.R. Tolkien', text: 'Mientras hay vida, hay esperanza.' },
  {
    source: 'J.R.R. Tolkien',
    text: 'No es la fuerza del cuerpo lo que cuenta, sino la fuerza del espíritu.'
  },
  {
    source: 'Dr. Seuss',
    text:
      'Sé quien eres y di lo que sientes, porque aquellos a quienes les importa no importan y los que sí importan no les importa.'
  },
  {
    source: 'Stephen King',
    text:
      'No se puede negar la risa, cuando llega, se deja caer en su sillón favorito y se queda todo el tiempo que quiera.'
  },
  {
    source: 'Abraham Lincoln',
    text:
      'Ningún hombre tiene una memoria lo suficientemente buena como para ser un mentiroso exitoso.'
  },
  { source: 'Mark Twain', text: 'Todas las generalizaciones son falsas, incluso esta.' },
  { source: 'Ronald Reagan', text: 'Una imagen vale 1000 negaciones.' },
  {
    source: 'Eleanor Roosevelt',
    text:
      'Las grandes mentes discuten las ideas; las mentes promedio discuten los eventos; las mentes pequeñas discuten con la gente.'
  },
  {
    source: 'J.K. Rowling',
    text:
      'Son nuestras elecciones las que muestran lo que realmente somos, mucho más que nuestras habilidades.'
  },
  {
    source: 'Dax Shephard',
    text:
      'El éxito es solo una guerra de desgaste. Ciertamente hay un elemento de talento que probablemente deberías poseer. Pero si te quedas el tiempo suficiente, al final sucederá algo.'
  },
  {
    source: 'Katherine Hepburn',
    text: 'Si siempre haces lo que te interesa, al menos una persona estará contenta. '
  },
  {
    source: 'Audrey Hepburn',
    text: 'Nada es imposible. ¡La misma palabra dice soy posible!'
  },
  {
    source: 'Wilma Rudolph',
    text:
      'Nunca subestimes el poder de los sueños y la influencia del espíritu humano. En este punto todos somos iguales: el potencial de grandeza vive dentro de cada uno de nosotros".'
  },
  {
    source: 'Francois de La Rochefoucauld',
    text: 'Para alcanzar la grandeza uno debe vivir como si nunca fuera a morir.'
  },
  {
    source: 'Edmund Hillary',
    text: 'La gente no decide volverse extraordinaria. Deciden lograr cosas extraordinarias.'
  },
  {
    source: 'Albert Einstein',
    text: 'Una persona que nunca cometió un error nunca intentó nada nuevo.'
  },
  {
    source: 'Jimmy Dean',
    text:
      'No puedo cambiar la dirección del viento, pero puedo ajustar mis velas para llegar siempre a mi destino.'
  },
  {
    source: 'Nelson Mandela',
    text: 'Un ganador es un soñador que nunca se rinde.'
  },
  {
    source: 'Eleanor Roosevelt',
    text: 'Nadie puede hacerte sentir inferior sin tu consentimiento.'
  },
  {
    source: 'Henry Ford',
    text: 'Ya sea que creas que puedes o creas que no, tienes razón.'
  },
  {
    source: 'Alice Walker',
    text:
      'La forma más común en que las personas renuncian a su poder es pensando que no tienen ninguno.'
  },
  {
    source: 'Oprah Winfrey',
    text:
      'Sé agradecido por lo que tienes; terminarás teniendo más. Si te concentras en lo que no tienes, nunca tendrás suficiente.'
  },
  {
    source: 'Hellen Keller',
    text:
      'Cuando se cierra una puerta de la felicidad, se abre otra, pero muchas veces miramos tanto tiempo la puerta cerrada que no vemos la que se nos ha abierto.'
  },
  {
    source: 'George Addair',
    text: 'Todo lo que siempre has querido está al otro lado del miedo.'
  },
  {
    source: 'Amelia Earhart',
    text: 'Lo más difícil es la decisión de actuar, el resto es mera tenacidad.'
  },
  {
    source: 'George Whitefield',
    text:
      'Continúa. No te detengas, no te demores en tu viaje, esfuérzate por alcanzar la meta que tienes por delante.'
  },
  {
    source: 'Charles Swindoll',
    text: 'La vida es el 10% de lo que me pasa y el 90% de cómo reacciono.'
  },
  {
    source: 'Michael Phelps',
    text:
      'Habrá obstáculos. Habrá escépticos. Habrá errores. Pero con trabajo duro, no hay límites.'
  },
  {
    source: 'Babe Ruth',
    text: 'Simplemente no puedes vencer a la persona que nunca se rinde.'
  },
  {
    source: 'Thomas Edison',
    text:
      'Muchos de los fracasos de la vida son de personas que no se dieron cuenta de lo cerca que estaban del éxito cuando se rindieron.'
  },
  {
    source: 'Aristóteles Onassis',
    text: 'Es durante nuestros momentos más oscuros cuando debemos enfocarnos para ver la luz.'
  },
  {
    source: 'Eleanor Roosevelt',
    text: 'Con el nuevo día vienen nuevas fuerzas y nuevos pensamientos.'
  },
  {
    source: 'Robert Louis Stevenson',
    text: 'No juzgues cada día por la cosecha que recoges, sino por las semillas que plantas.'
  },
  {
    source: 'Vincent Van Gogh',
    text:
      'Si escuchas una voz dentro de ti que dice "no puedes pintar", entonces pinta y esa voz se callará.'
  },
  {
    source: 'Roy T. Bennett',
    text:
      'No te dejes llevar por los miedos en tu mente. Déjate llevar por los sueños de tu corazón.'
  },
  {
    source: 'Mark Cuban',
    text:
      'Despierta siempre con una sonrisa sabiendo que hoy te divertirás logrando lo que otros tienen demasiado miedo de hacer.'
  },
  {
    source: 'Maya Angelou',
    text: 'Si no te gusta algo, cámbialo. Si no puedes cambiarlo, cambia tu actitud.'
  },
  {
    source: 'Jesse Owens',
    text:
      'Encuentra lo bueno. Está a tu alrededor. Encuéntralo, exhíbelo y empezarás a creer en él.'
  },
  {
    source: 'Audre Lorde',
    text:
      'Si no me definiera por mí misma, me vería envuelta en las fantasías de otras personas y me comerían viva.'
  },
  {
    source: 'Viola Davis',
    text:
      'No tengo tiempo para quedarme despierto toda la noche preocupándome por lo que alguien que no me ama tenga que decir sobre mí.'
  },
  {
    source: 'Frederick Douglass',
    text: 'Oré durante veinte años, pero no recibí respuesta hasta que oré con mis piernas.'
  },
  {
    source: 'Barack Obama ',
    text:
      'El cambio no vendrá si esperamos a otra persona o si esperamos otro momento. Somos los que estábamos esperando. Somos el cambio que buscamos.'
  },
  {
    source: 'James Baldwin',
    text:
      'Nunca hay tiempo en el futuro en el que trabajemos en nuestra salvación. El desafío está en el momento; el momento siempre es ahora.'
  },
  {
    source: 'Dr. Martin Luther King, Jr.',
    text:
      'Si no puedes volar entonces corre, si no puedes correr entonces camina, si no puedes caminar entonces gatea, pero hagas lo que hagas tienes que seguir avanzando.'
  },
  {
    source: 'Dr. Mae Jamison',
    text: 'Nunca te dejes limitar por la imaginación limitada de otras personas.'
  },
  {
    source: 'Phylicia Rashad',
    text:
      'Siempre hay algo que sugiere que nunca serás quien querías ser. Tu elección es tomarlo o seguir avanzando.'
  },
  {
    source: 'Beyoncé Knowles',
    text: 'No se te da poder. Tienes que aceptarlo.'
  },
  {
    source: 'Arthur Ashe',
    text:
      'Una clave importante del éxito es la confianza en uno mismo. Una clave importante para la confianza en uno mismo es la preparación.'
  },
  {
    source: 'Frank Sinatra',
    text: 'La mejor venganza es el éxito masivo.'
  },
  {
    source: 'Steve Jobs',
    text: 'Tu tiempo es limitado, así que no lo pierdas viviendo la vida de otra persona.'
  },
  {
    source: 'Zig Ziglar',
    text:
      'La gente suele decir que la motivación no dura. Bueno, tampoco un baño. Es por ello que nos recomiendan bañarnos a diario.'
  },
  {
    source: 'Jim Rohn',
    text: 'Eres el promedio de las cinco personas con las que pasas más tiempo.'
  },
  {
    source: 'Vince Lombardi',
    text:
      'La diferencia entre una persona exitosa y los demás no es la falta de fuerza, ni la falta de conocimiento, sino más bien la falta de voluntad.'
  },
  {
    source: 'Bruce Lee',
    text: 'Si amas la vida, no pierdas el tiempo, porque de tiempo es de lo que se compone la vida.'
  },
  {
    source: 'Abraham Lincoln',
    text:
      'Las cosas pueden llegar a aquellos que esperan, pero solo las cosas que dejan los que se dan prisa.'
  },
  {
    source: 'John Lennon',
    text: 'La vida es lo que sucede mientras estás ocupado haciendo otros planes.'
  },
  {
    source: 'Angelica Monroy',
    text: 'Abraza tus vulnerabilidades, acéptalas y perdónate.'
  },
  {
    source: 'Iris Soto',
    text:
      'Frente a los desafíos difíciles, recuerda que estas son bendiciones disfrazadas, empújalas con fe.'
  },
  {
    source: 'Carlos Santana',
    text:
      'La posesión más valiosa que puedes tener es un corazón abierto. El arma más poderosa que puedes ser es un instrumento de paz.'
  },
  {
    source: 'César Chávez',
    text:
      'La preservación de la propia cultura no requiere desprecio o falta de respeto a otras culturas.'
  },
  {
    source: 'Gwendolyn Brooks',
    text:
      'No permitas que nadie te llame minoría si eres negro, hispano o perteneces a otro grupo étnico. Tú no eres menos que los demás.'
  },
  {
    source: 'Dolly Parton ',
    text: 'A mi modo de ver, si quieres el arcoíris, tienes que aguantar la lluvia.'
  },
  {
    source: 'Dr. Seuss',
    text: 'A veces, nunca sabrás el valor de un momento hasta que se convierte en un recuerdo.'
  },
  {
    source: 'C.S. Lewis',
    text: 'Nunca serás demasiado viejo para fijarte una nueva meta o soñar un nuevo sueño.'
  },
  {
    source: 'Helen Keller',
    text: 'Nunca bajes la cabeza. Mantente siempre firme. Mira al mundo directamente a los ojos.'
  },
  {
    source: 'Theodore Roosevelt',
    text: 'Cree y ya estarás a mitad de camino.'
  },
  {
    source: 'Carol Burnett',
    text: 'Cuando tienes un sueño, tienes que agarrarlo y nunca dejarlo ir.'
  },
  {
    source: 'Albert Einstein',
    text: 'La vida es como andar en bicicleta. Para mantener el equilibrio debes seguir moviéndote.'
  },
  {
    source: 'Ella Fitzgerald',
    text: 'La vida es como andar en bicicleta. Para mantener el equilibrio debes seguir moviéndote.'
  },
  {
    source: 'Amy Poehler',
    text: 'Limita tus "siempre" y tus "nunca".'
  },
  {
    source: 'Maya Angelou',
    text: 'Intenta ser un arcoíris en la nube de otra persona.'
  },
  {
    source: '"Camilla Eyring Kimball',
    text: 'La vida feliz no se encuentra, se hace.'
  },
  {
    source: 'E.E. Cummings',
    text: 'El día más perdido es aquel que no tiene risas.'
  },
  {
    source: 'George Eliot',
    text: 'Nunca es demasiado tarde para ser lo que pudiste haber sido.'
  },
  {
    source: 'Hazrat Inayat Khan',
    text: 'Algunas personas buscan un lugar hermoso. Otros embellecen un lugar.'
  },
  {
    source: 'Lindsey Von',
    text: 'La vida cambia muy rápido, de una manera muy positiva, si lo permites.'
  },
  {
    source: 'Malala Yousafzai',
    text: 'Hagamos nuestro futuro ahora y hagamos realidad nuestros sueños del mañana.'
  },
  {
    source: 'Mandy Hale',
    text:
      'No siempre necesitas un plan. A veces solo necesitas respirar, confiar, soltarte y ver qué sucede.'
  },
  {
    source: 'Meghan Markle',
    text: 'Eres suficiente tal como eres.'
  },
  {
    source: 'Martin Luther King Jr.',
    text: 'Si no puedo hacer grandes cosas, puedo hacer pequeñas cosas de una gran manera.'
  },
  {
    source: 'Nicole Kidman',
    text: 'La vida tiene todos esos giros y vueltas. Tienes que agarrarte fuerte y listo.'
  },
  {
    source: 'Oprah Winfrey',
    text: 'Si miras lo que tienes en la vida, siempre tendrás más.'
  },
  {
    source: 'Reese Witherspoon',
    text: 'Con el entrenamiento y la determinación adecuados, puedes lograr cualquier cosa.'
  },
  {
    source: 'Roald Dahl',
    text:
      'Si tienes buenos pensamientos, brillarán en tu rostro como rayos de sol y siempre te verás encantador.'
  },
  {
    source: 'Robin Williams',
    text: 'No importa lo que la gente te diga, las palabras y las ideas pueden cambiar el mundo.'
  },
  {
    source: 'Rosa Parks',
    text: 'Cada persona debe vivir su vida como modelo para los demás.'
  },
  {
    source: 'Serena Williams',
    text: 'Un campeón no se define por sus victorias sino por cómo se recupera cuando cae.'
  },
  {
    source: 'Sheryl Sandberg',
    text: 'La motivación proviene de trabajar en las cosas que nos importan.'
  },
  {
    source: 'Walt Whitman',
    text: 'Mantén tu rostro siempre hacia la luz del sol y las sombras caerán detrás de ti.'
  },
  {
    source: 'John Bunyan',
    text:
      'No has vivido el día de hoy hasta que hayas hecho algo por alguien que nunca podrá pagarte.'
  },
  {
    source: 'Walt Whitman',
    text: 'Cada momento de luz y oscuridad es un milagro.'
  },
  {
    source: 'Will Rogers',
    text: 'Incluso si estás en el camino correcto, te atropellarán si te quedas ahí parado.'
  },
  {
    source: 'Mark Zuckerberg',
    text:
      'El mayor riesgo es no asumir ningún riesgo... En un mundo que cambia muy rápido, la única estrategia que te garantiza el fracaso es no correr riesgos.'
  },
  {
    source: 'Napoleon Hill',
    text: 'Lo que la mente puede concebir, lo puede lograr.'
  },
  {
    source: 'Ted Murphy',
    text: 'Si no da un poco de miedo, probablemente no valga la pena.'
  },
  {
    source: 'Sydney Harris',
    text:
      'Cuando escucho a alguien suspirar: "La vida es dura", siempre me siento tentado a preguntar: "¿Comparado con qué?"'
  },
  {
    source: 'Arthur Schopenhauer',
    text:
      'Toda verdad pasa por tres etapas antes de ser reconocida. En la primera, se ridiculiza. En la segunda, hay oposición. En la tercera, se le considera evidente.'
  },
  {
    source: 'John F. Kennedy',
    text: 'Si no somos nosotros, ¿quién? Si no es ahora, ¿cuándo?'
  },
  {
    source: 'Jack Canfield ',
    text:
      'No te preocupes por los fracasos, preocúpate por las oportunidades que pierdes cuando ni siquiera lo intentas.'
  },
  {
    source: 'Sir Claus Moser',
    text: 'La educación cuesta dinero, pero es más cara la ignorancia.'
  },
  {
    source: 'John Wooden',
    text: 'No permitas que lo que no puedes hacer interfiera con lo que puedes hacer.'
  },
  {
    source: 'Babe Ruth',
    text: 'Cada strike me acerca al siguiente jonrón.'
  },
  {
    source: 'Dr. Martin Luther King Jr.',
    text:
      'El fin de nuestras vidas comienza el día en que guardamos silencio sobre las cosas que importan.'
  },
  {
    source: 'Maya Angelou',
    text:
      'El prejuicio es una carga que confunde al pasado, amenaza al futuro y vuelve inaccesible el presente.'
  },
  {
    source: 'Rosa Parks',
    text:
      'Para lograr un cambio, no debes tener miedo de dar el primer paso. Fracasaremos cuando no lo intentemos.'
  },
  {
    source: 'James Baldwin',
    text:
      'No todo lo que se enfrenta se puede cambiar, pero nada se puede cambiar hasta que se enfrenta.'
  },
  {
    source: 'Dr. Martin Luther King Jr.',
    text:
      'La oscuridad no puede acabar con la oscuridad; solo la luz puede hacerlo. El odio no puede acabar con el odio; solo el amor puede hacerlo.'
  },
  {
    source: 'Malcolm X',
    text: 'Un hombre que no se pone de pie por nada, se caerá de la nada.'
  },
  {
    source: 'Dr. Cornel West',
    text: 'La justicia es lo que parece el amor en público.'
  },
  {
    source: 'Malcolm X',
    text:
      'No se puede separar la paz de la libertad porque nadie puede estar en paz a menos que tenga su libertad.'
  },
  {
    source: 'Andrew Hendrixson',
    text: 'Cualquiera que haya hecho algo importante, fue disciplinado.'
  },
  {
    source: 'Coco Chanel',
    text:
      'No pierdas el tiempo golpeando una pared con la esperanza de transformarla en una puerta.'
  },
  {
    source: 'Albert Einstein',
    text: 'La creatividad es la inteligencia divirtiéndose.'
  },
  {
    source: 'Grace Coddington',
    text:
      'Mantén siempre los ojos abiertos. Sigue mirando. Porque todo lo que veas puede inspirarte.'
  },
  {
    source: 'Henry David Thoreau',
    text:
      'Lo que obtienes al lograr tus metas no es tan importante como en lo que te conviertes al lograr tus metas.'
  },
  {
    source: 'Seth Godin',
    text:
      'En lugar de preguntarte cuándo serán tus próximas vacaciones, tal vez deberías crear una vida de la que no necesites escapar.'
  },
  {
    source: 'John Maxwell',
    text: 'A veces se gana, a veces se aprende.'
  },
  {
    source: 'Audre Lorde',
    text:
      'Cuidarme no es autocomplacencia, es autoconservación, y eso es un acto de guerra política.'
  },
  {
    source: 'Assata Shakur',
    text: 'Los sueños y la realidad son opuestos. La acción los sintetiza.'
  },
  {
    source: 'Wangari Maathai',
    text: 'Hay oportunidades incluso en los momentos más difíciles.'
  },
  {
    source: 'Rev. Peter Marshall',
    text:
      'Pensemos en la libertad no como el derecho a hacer lo que queramos, sino como la oportunidad de hacer lo correcto.'
  },
  {
    source: 'Martha Grimes',
    text: 'No sabemos quiénes somos hasta que vemos qué podemos hacer.'
  },
  {
    source: 'Vidal Sassoon ',
    text: 'Toma un buen consejo. Asegúrate de que sea un buen consejo, luego hazlo a tu manera.'
  },
  {
    source: 'Adelaide Anne Procter',
    text: 'Siempre podemos ser lo que pudimos haber sido.'
  },
  {
    source: 'George Patton',
    text:
      'Nunca le digas a la gente cómo hacer las cosas. Diles qué hacer y te sorprenderán con su ingenio.'
  },
  {
    source: 'Robert Frost ',
    text:
      'La mayoría de los cambios que creemos ver en la vida se deben a que las verdades están a favor y en contra.'
  },
  {
    source: 'Bob Black',
    text:
      'Tú eres lo que haces. Si haces un trabajo aburrido, estúpido y monótono, es probable que termines siendo aburrido, estúpido y monótono.'
  },
  {
    source: 'Georg Wilhelm Friedrich Hegel',
    text: 'Nada grandioso en el mundo se ha logrado sin pasión.'
  },
  {
    source: 'Robert Louis Stevenson',
    text: 'No juzgues cada día por la cosecha que recojas, sino por las semillas que plantes.'
  },
  {
    source: 'Friedrich Nietzsche',
    text:
      'En el mundo no hay más que un camino que solo tú puedes recorrer: ¿A dónde conduce? No preguntes, síguelo.'
  },
  {
    source: 'Pablo Picasso ',
    text: 'El arte es una mentira que nos hace darnos cuenta de la verdad.'
  },
  {
    source: 'Henry David Thoreau',
    text:
      'Si uno avanza con confianza en la dirección de sus sueños y se esfuerza por vivir la vida que ha imaginado, encontrará un éxito inesperado en horas comunes.'
  },
  {
    source: 'Bob Dylan',
    text: 'No conviene a nadie pensar en cómo serán percibidos mañana. Te duele a la larga.'
  },
  {
    source: 'Stephen Vincent Benet',
    text:
      '¡La vida no se pierde con la muerte! La vida se pierde minuto a minuto, día tras día, en miles de formas pequeñas e indiferentes.'
  },
  {
    source: 'Mary Shelley',
    text: 'Nada es tan doloroso para la mente humana como un cambio grande y repentino.'
  },
  {
    source: 'E.M. Forster',
    text: 'La vida implica coraje o deja de ser vida.'
  },
  {
    source: 'Ellen DeGeneres',
    text:
      'Conocí la compasión al ser discriminado. Todo lo malo que me ha pasado me ha enseñado compasión.'
  },
  {
    source: 'James Cameron',
    text:
      'El fracaso tiene que ser una opción... Ningún esfuerzo importante que requiriera innovación se realizó sin riesgo.'
  },
  {
    source: 'Mandy Hale',
    text:
      'Sé lo suficientemente valiente como para vivir la vida en tus propios términos y nunca te disculpes por ello.'
  },
  {
    source: 'Debbi Fields',
    text: 'El mayor fracaso de la vida es no intentarlo nunca.'
  },
  {
    source: 'Elizabeth Barrett Browning',
    text: 'No midas el trabajo hasta que termine el día y hayas terminado el trabajo.'
  },
  {
    source: 'Ingvar Kamprad',
    text:
      'Cometer errores es un privilegio de los activos, de aquellos que pueden corregir sus errores y hacerlo bien.'
  },
  {
    source: 'Leo Tolsto',
    ttext: 'Todo el mundo piensa en cambiar a la humanidad y nadie piensa en cambiarse a sí mismo.'
  },
  {
    source: 'Aldous Huxley',
    text:
      'Existe al menos un rincón del universo que con toda seguridad puedes mejorar, y eres tú mismo.'
  },
  {
    source: 'Theodore Thornton Munger',
    text: 'Nada es más común que los hombres talentosos fracasados.'
  },
  {
    source: 'Steve Jobs',
    text:
      'Estoy convencido de que aproximadamente la mitad de lo que separa a los empresarios exitosos de los no exitosos es pura perseverancia. Es muy dificil.'
  },
  {
    source: 'Dwight D. Eisenhower',
    text: 'Los planes no valen nada, pero la planificación lo es todo.'
  },
  {
    source: 'Booker T. Washington',
    text: 'Hay dos formas de ejercer la fuerza: una empuja hacia abajo y la otra tira hacia arriba.'
  },
  {
    source: 'James Thurber',
    text:
      'No miremos hacia atrás con ira, ni hacia adelante con miedo, sino alrededor con precaución.'
  },
  {
    source: 'Nelson Mandela',
    text: 'Que tus elecciones reflejen tus esperanzas, no tus miedos.'
  },
  {
    source: 'Steve Jobs',
    text: 'Las cosas no tienen que cambiar el mundo para ser importantes.'
  },
  {
    source: 'Albert Einstein',
    text:
      'No es posible mantener la paz usando la fuerza; solo se puede alcanzar con el entendimiento.'
  },
  {
    source: 'Frederick Douglass',
    text: 'Ningún hombre puede degradar el alma que está dentro de mí.'
  },
  {
    source: 'Peter Drucker',
    text: 'Lo más importante en la comunicación es escuchar lo que no se dice.'
  },
  {
    source: 'Molière',
    text: 'Pensar en quienes amamos es un buen condimento para la alegría.'
  },
  {
    source: 'William Feather',
    text: 'Ningún hombre es un fracaso si disfruta de la vida.'
  },
  {
    source: 'Pablo Picasso',
    text: 'Aprende las reglas como un profesional, para que puedas romperlas como un artista.'
  },
  {
    source: 'Ursula Le Guin',
    text:
      'Es bueno tener una meta hacia la que dirigirse, pero, al final, lo que importa es el viaje.'
  },
  {
    source: 'John F. Kennedy',
    text: 'La conformidad es carcelera de la libertad y enemiga del crecimiento.'
  },
  {
    source: 'Robert Anthony',
    text: 'Algunas personas beben de la fuente del conocimiento. Otros simplemente hacen gárgaras.'
  },
  {
    source: 'Ralph Waldo Emerson',
    text: 'Todo artista fue primero un aficionado.'
  },
  {
    source: 'Samuel Butler',
    text:
      'Todos los animales, excepto el hombre, saben que la principal ocupación de la vida es disfrutarla.'
  },
  {
    source: 'Bruce Lee',
    text: 'Absorbe lo que es útil. Descarta lo que no lo es. Agrega lo que es exclusivamente tuyo.'
  },
  {
    source: 'Earl Nightingale',
    text: 'Nos volvemos lo que pensamos.'
  },
  {
    source: 'Theodore Vail',
    text: 'Se pueden superar las dificultades reales; solo las imaginarias son invencibles.'
  },
  {
    source: 'Washington Irving',
    text:
      'Las mentes pequeñas están domesticadas y sometidas por la desgracia, pero las grandes mentes se elevan por encima de ellas.'
  },
  {
    source: 'Arnold Bennett',
    text:
      'Cualquier cambio, incluso un cambio a mejor, siempre va acompañado de inconvenientes e incomodidades.'
  },
  {
    source: 'Dhirubhai Ambani',
    text:
      'Si no construyes tu sueño, alguien más te contratará para que le ayudes a construir el suyo.'
  },
  {
    source: 'Mario Andretti',
    text: 'Si las cosas parecen estar bajo control, simplemente no vas lo suficientemente rápido.'
  },
  {
    source: 'Oprah Winfrey',
    text:
      'Sé agradecido por lo que tienes; terminarás teniendo más. Si te concentras en lo que no tienes, nunca tendrás suficiente.'
  },
  {
    source: 'Helen Keller',
    text:
      'Evitar el peligro no es más seguro a largo plazo que la exposición total. Los temerosos son atrapados con tanta frecuencia como los valientes.'
  },
  {
    source: 'Thomas Paine',
    text: 'Cuanto más duro es el conflicto, más glorioso será el triunfo.'
  },
  {
    source: 'Frank Tyger',
    text: 'No hay mayor préstamo que un oído comprensivo.'
  },
  {
    source: 'Phyllis Theroux',
    text: 'Los errores son el puente habitual entre la inexperiencia y la sabiduría.'
  },
  {
    source: 'Gaylord Nelson',
    text:
      'La prueba máxima de la conciencia del hombre puede ser su disposición a sacrificar algo hoy por las generaciones futuras cuyas palabras de agradecimiento no serán escuchadas.'
  },
  {
    source: 'Sarah Grand',
    text:
      'Nuestra opinión de las personas depende menos de lo que vemos en ellos que de lo que nos hacen ver en nosotros mismos.'
  },
  {
    source: 'George Santayana',
    text: 'No hay cura para el nacimiento ni la muerte, salvo disfrutar del intervalo.'
  },
  {
    source: 'Margaret Chase Smith',
    text: 'Cuando la gente te sigue diciendo que no puedes hacer algo, te gusta intentarlo.'
  },
  {
    source: 'André Gide',
    text: 'Cree en aquellos que buscan la verdad; duda de aquellos que la encuentran.'
  },
  {
    source: 'Frank Yerby',
    text: 'La madurez se alcanza el día en que no necesitamos que nos mientan sobre nada.'
  },
  {
    source: 'Charles Dickens',
    text: 'Nadie es inútil en este mundo si aligera la carga de alguien más.'
  },
  {
    source: 'Merry Browne',
    text:
      'Espera que las personas sean mejores de lo que son; eso les ayuda a mejorar. Pero no te decepciones cuando no lo sean; les ayuda a seguir intentándolo.'
  },
  {
    source: 'Doug Larson',
    text:
      'La sabiduría es la cualidad que evita que te metas en situaciones en las que la necesitas.'
  },
  {
    source: 'Lao-Tse',
    text:
      'Para obtener conocimiento, agrega cosas todos los días. Para alcanzar la sabiduría, resta cosas todos los días.'
  }
]
